import { DatosPorSegmentoEntity } from "./datos_por_segmento_entity";

export class DatosGeneralesEntity {
    constructor(
        public CliCod ?:number,
        public  RazonSocial?:string,
        public  NombreComercial?:string,
        public  Ruc?:string,
        public  CodigoActividadEconomica ?:number,
        public  GiroDelNegocio ?:string,
        public  FechaInicioTS ?:Date,
        public  DatosPorSegmento?: DatosPorSegmentoEntity[],
        public  DatosPorSegmentoModificados?: DatosPorSegmentoEntity[],
        public CodigoUsuario?: number  
    ){

    }
} 
 
export class CampoValor {
    constructor(
      public Campo?: string,
      public Valor?: number,
      public ValorExtra?: number,
      public ValorTexto?: string,
      public Editado?: boolean
    ) { }
  }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/datos_generales_entity.ts